import { useModals } from '@frontend/modal';
import { useAccountRepository } from '@frontend/repository';

import { useAppDispatch } from '../../../redux/store';

export const useScheduleDetailModal = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const { openModal } = useModals();
    const updateReceiversModalId = 'update-receivers-modal';
    return {
        currentAccount,
        dispatch,
        openModal,
        updateReceiversModalId
    };
};
